import {EventBroker} from "@frontend/lib/utils/event-broker";

export const EVENTS = {
    SAVED: 'SAVED',
    INIT: 'INIT',
    CLOSED: 'CLOSED'
}

export const makeTemplateImageEditableEventBroker = new EventBroker();
